import { memo } from 'react'
import { Button } from '../atoms'

export interface PinLocationButtonProps {
  onClick: () => void
  disabled?: boolean
  className?: string
  isActive?: boolean
}

export const PinLocationButton = memo(({ onClick, disabled, className, isActive = false }: PinLocationButtonProps) => {
  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      variant={isActive ? 'primary' : 'secondary'}
      className={`flex items-center justify-center gap-1.5 sm:gap-2 text-xs sm:text-sm md:text-base py-2.5 sm:py-3 font-semibold min-h-[44px] touch-manipulation ${className || ''}`}
      aria-label={isActive ? "Pin mode active - Click on the map to pin a location" : "Enable pin mode to place a location on the map"}
      title={isActive ? "Pin mode active - Click anywhere on the map to pin that location and discover nearby points of interest" : "Enable pin mode, then click anywhere on the map to pin that location"}
    >
      <span className="hidden sm:inline">{isActive ? 'Pin Mode Active' : 'Pin Location'}</span>
      <span className="sm:hidden">{isActive ? 'Active' : 'Pin'}</span>
    </Button>
  )
})

PinLocationButton.displayName = 'PinLocationButton'
